import { RowExtraInfo, RowInfoType } from 'components/customComponents/Controls/RMTable';
import { IOption } from 'components/input/selectInput';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { cloneDeep } from 'lodash';
import React from 'react';
import { showAlertSnackBar } from 'utils/Global';

export const dewarTableColumns: {
  accessor: string;
  Header: string;
  className?: string;
  editOptions?: { inputType: React.HTMLInputTypeAttribute; options?: IOption[] };
}[] = [
  {
    accessor: 'name',
    Header: 'Dewar Name',
    className: 'dewar-puck-Name',
    editOptions: { inputType: 'text' },
  },
  {
    accessor: 'puckCount',
    Header: 'Puck Count',
    className: 'puckCount',
    editOptions: { inputType: 'text' },
  },
  {
    accessor: 'enable',
    Header: 'Enable',
    className: 'dewarInUse',
  },
];

export const puckTableColumns = (puckTypes) => {
  const columns: {
    accessor: string;
    Header: string;
    className?: string;
    editOptions?: { inputType: React.HTMLInputTypeAttribute; options?: IOption[] };
  }[] = [
    {
      accessor: 'name',
      Header: 'Puck Name',
      className: 'dewar-puck-Name',
      editOptions: { inputType: 'text' },
    },
    {
      accessor: 'barcode',
      Header: 'Barcode',
      className: 'barcode',
      editOptions: { inputType: 'text' },
    },
    {
      accessor: 'puckType',
      Header: 'Puck Type',
      className: 'puckType',
      editOptions: { inputType: 'select', options: puckTypes },
    },
    {
      accessor: 'puckLogo',
      Header: '',
      className: 'puckLogo',
    },
    {
      accessor: 'pinCount',
      Header: 'Pin Count',
      className: 'pinCount',
    },
    {
      accessor: 'enable',
      Header: 'Enable',
      className: 'puckInUse',
    },
  ];
  return columns;
};

export const preDelete = (
  list,
  setList,
  selectedRowIndex,
  setShowDeleteModal,
  setIsDirty,
  deleteList,
) => {
  const newList = [...list];
  selectedRowIndex.forEach((idx) => {
    const item = newList[idx];
    if (item?.id) {
      deleteList.push(item.id);
    }
  });
  const filteredList = newList.filter((item, i) => !selectedRowIndex.includes(i));

  setList(filteredList.map((item, i) => ({ ...item, index: i })));
  setShowDeleteModal(false);
  setIsDirty(true);
};

export const onDelete = (
  list,
  selectedIndexs,
  title,
  setShow,
  setRowError,
  setSelectedIds,
  inUseAlert,
) => {
  const rowInfoError: RowExtraInfo = {};
  selectedIndexs.forEach((idx) => {
    let msg = '';
    if (list[idx]?.inUseFlag) {
      msg = `You cannot edit or delete this ${title} because it is used in the crystal definition.\n`;
      inUseAlert(title);
    }
    if (msg) {
      rowInfoError[idx] = { msg, type: RowInfoType.Error };
    }
  });

  if (!Object.keys(rowInfoError).length) {
    setShow(true);
  }
};

export const onCellChange = (
  e,
  type,
  index,
  key,
  dataList,
  setList,
  setIsDirty,
  puckTypes,
  inUseAlert,
) => {
  const list = cloneDeep(dataList);
  const idx = list.findIndex((item) => item.index == index);
  if (e.target.type === 'checkbox' && key === 'enable') {
    list[idx][key] = !list[idx][key];
    list[idx]['rowIsDirty'] = true;
    setList([...list]);
    setIsDirty(true);
  } else if (list[idx].inUseFlag) {
    inUseAlert(type);
  } else if (key === 'barcode' && e.target.value?.length > 50) {
    showAlertSnackBar(
      EAlertType.ERROR,
      ESnackBarPosition.TOP,
      `Barcode length limit exceeded.`,
    );
  } else if (key === 'name' && e.target.value?.length > 100) {
    showAlertSnackBar(
      EAlertType.ERROR,
      ESnackBarPosition.TOP,
      `Name length limit exceeded.`,
    );
  } else {
    if (e.target.type === 'number') {
      list[idx][key] = parseInt(e.target.value);
    } else {
      list[idx][key] = e.target.value;
    }
    if (key === 'puckType' && puckTypes.length) {
      list[idx]['puckTypeId'] = puckTypes.find(
        (x) => x.title === list[idx]?.puckType,
      )?.id;
    }
    list[idx]['rowIsDirty'] = true;
    setList([...list]);
    setIsDirty(true);
  }
};
